import React from 'react'
import { useHistory } from 'react-router-dom'

import { useTheme } from '@material-ui/core/styles'

import AboutUs from 'components/AboutUs'
import Concept from 'components/Concept'
import CustomButton from 'components/CustomButton'
import FAQ from 'components/FAQ'
import SupportList from 'components/SupportList'
import HowItWorks from 'components/HowItWorks'
import MainImage from 'components/MainImage'
import Reward from 'components/Reward'
import EventList from 'pages/EventList'
import NewsList from 'pages/NewsList'
import Information from 'components/Information'
import ButtonBase from '@material-ui/core/ButtonBase'

export default function Top() {
  const { palette, spacing } = useTheme()
  const { push } = useHistory()

  const More = ({ text, href }) => (
    <div
      style={{
        marginBottom: spacing(6),
        background: palette.background.paper,
        padding: spacing(3),
      }}
    >
      <CustomButton
        arrow
        onClick={() => {
          if (href.startsWith('/')) {
            push(href)
          } else {
            window.open(href)
          }
        }}
      >
        {text}
      </CustomButton>
    </div>
  )

  return (
    <div style={{ background: palette.background.default }}>
      <MainImage src="/images/main.jpg" alt="トップ" type="top" />
        <div>
          <Information text='本イベントはRuntripアプリ（無料）をインストールしてご参加ください' />
          <div style={{ display: 'flex', justifyContent: 'center', gap: '30px' }}>
            <ButtonBase
              style={{ marginBottom: spacing(6) }}
              onClick={() => window.open('https://runtrip-web.onelink.me/Pprx/vrwctop')}
            >
              <img height={40} src='/images-static/app_dl_ios.png' alt='' />
            </ButtonBase>
            <ButtonBase
              style={{ marginBottom: spacing(6) }}
              onClick={() => window.open('https://runtrip-web.onelink.me/Pprx/vrwctop')}
            >
              <img height={40} src='/images-static/app_dl_android.png' alt='' />
            </ButtonBase>
          </div>
        </div>
      <Concept />
      {Boolean(process.env.REACT_APP_CONCEPT_HREF) && (
        <More text="詳細を見る" href={process.env.REACT_APP_CONCEPT_HREF} />
      )}
      <NewsList limit={3} />
      <More text="お知らせ一覧" href="/news" />
      <HowItWorks />
      <Reward />
      <EventList limit={7} />
      <More text="イベント一覧" href="/events" />
      <FAQ />
      <SupportList />
      <AboutUs />
    </div>
  )
}
